import { render, staticRenderFns } from "./ModalMessaging.vue?vue&type=template&id=6f11aebc"
import script from "./ModalMessaging.vue?vue&type=script&lang=js"
export * from "./ModalMessaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports